import { alpha, Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import { colorsPalette } from '../../../../theme';

const useStyles = (scrolled) =>
  makeStyles((theme: Theme) => {
    return createStyles({
      wrapper: {
        display: 'flex',
        flexDirection: 'column',
        [theme.breakpoints.up('xl')]: {
          flexDirection: 'row',
        },
      },
      headerBackgroundBox: {
        width: '100vw',
        position: 'absolute',
        background: 'transparent',
        height: scrolled ? 80 : 100,
        left: 0,
        top: 0,
        bottom: 0,
        right: 0,
        opacity: 0,
        display: 'none',
        [theme.breakpoints.up('xl')]: {
          display: 'block',
        },
      },
      menuItem: {
        borderBottom: `1px solid ${alpha(colorsPalette.white, 0.15)}`,
        '&$lastMenuItem': {
          borderBottom: 'none',
        },
        [theme.breakpoints.up('xl')]: {
          borderBottom: 'none',
          '&.hasSubItems:hover ~ $backgroundBox': {
            height: '100vh',
            opacity: 1,
          },
          '&.hasSubItems:hover ~ $headerBackgroundBox': {
            opacity: 1,
            background: colorsPalette.blackSecondary,
          },
        },
      },
      lastMenuItem: {},
    });
  });

export default useStyles;
